export default "__VITE_ASSET__VopwsvV0__"